import moment from "moment";
import queryString from "query-string";
import { Link } from "react-router-dom";
import { FlagIcon } from "react-flag-kit";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import Pagination from "../../components/Pagination";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import PlaceholderText from "../../components/Placeholder/PlaceholderText";
import { getStudentClass, postReversePayment } from "../../store/middleware/companyManager.middleware";

import { StudentManagementCss, Next } from "./styles";

function Classes() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { studentManagement } = useSelector((state) => state.companyManagerReducer);

  const studentId = studentManagement.students[0].id;

  const [open, setOpen] = useState(false);
  const [dialogMsg, setDialogMsg] = useState("");
  const [userNextClasses, setUserNextClasses] = useState([]);
  const [filter, setFilter] = useState({ pageNumber: 1, pageSize: 10 });
  const [pagination, setPagination] = useState({
    pageNumber: 0,
    pageSize: 0,
    totalFound: 0,
    totalPages: 0,
  });
  const [tagDays] = useState([
    "WEEK_SUNDAY",
    "WEEK_MONDAY",
    "WEEK_TUESDAY",
    "WEEK_WEDNESDAY",
    "WEEK_THURSDAY",
    "WEEK_FRIDAY",
    "WEEK_SATURDAY",
  ]);

  const handlePagination = (page) => {
    setFilter((state) => ({ ...state, ["pageNumber"]: Number(page) }));
    applyFilters();
  };

  const applyFilters = () => {
    let cleanFilter = { ...filter };
    const query = queryString.stringify(cleanFilter);

    dispatch(getStudentClass(studentId, query))
      .then((res) => {
        setUserNextClasses(res.items);
        setPagination({
          pageNumber: res.pageNumber,
          pageSize: res.pageSize,
          totalFound: res.totalFound,
          totalPages: res.totalPages,
        });
      })
      .catch((err) => console.log(err.response.data));
  };

  const handleReversePayment = (id) => {
    dispatch(postReversePayment(id))
      .then(() => {
        applyFilters();
        setOpen(false);
      })
      .catch((e) => {
        let errMsg = e.data.error.message !== undefined ? e.data.error.message : e.data.error.message;

        setDialogMsg(errMsg);
        setOpen(true);
      });
  };

  const closeAlert = () => setOpen(false);

  const CancelCardItem = (item) => {
    let textCancel = "";

    const isCanceled = item.status === "canceled";
    const iscanceledFree = item.status === "canceledFree";
    const isCanceledByLingo = item.status === "canceledLingo";
    const iscanceledFreeLingo = item.status === "canceledFreeLingo";

    if (isCanceled) textCancel = "CANCELLED_OUT_lIMIT";
    else if (isCanceledByLingo || iscanceledFreeLingo) textCancel = "CANCELLED_LINGO";
    else if (iscanceledFree) textCancel = "CLASS_CANCELED";

    return isCanceled || iscanceledFree || isCanceledByLingo || iscanceledFreeLingo ? (
      <div className="status">
        <h4 className="cancel" style={isCanceled ? { color: "#ffa500" } : { color: "red" }}>
          {t(textCancel)}
        </h4>

        <Link to={`/class-details/` + item.id}>
          <button>
            {t("BTN_VIEW")} <i className="fa fa-angle-right" aria-hidden="true"></i>
          </button>
        </Link>
      </div>
    ) : null;
  };

  useEffect(() => {
    applyFilters();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <StudentManagementCss>
        <Next>
          {!userNextClasses ? (
            <PlaceholderText labe="No result" />
          ) : (
            <>
              <div>
                {userNextClasses?.map((item) => {
                  return (
                    <div className="nextClass" key={item.id}>
                      {item.status == "canceled" && <div className="borderCancelled"></div>}
                      <div className="boxClass">
                        <div className="date">
                          <h3>
                            {moment(item.scheduledDate).format(t("DATE_FORMAT"))}
                            &nbsp; • &nbsp;
                            {t(tagDays[new Date(item.scheduledDate).getUTCDay()].toUpperCase())}
                            &nbsp; • &nbsp;
                            {moment(item.scheduledStartTime, "HH:mm:ss").format("hh:mm A")}
                            &nbsp; - &nbsp;
                            {moment(item.scheduledEndTime, "HH:mm:ss").format("hh:mm A")}
                          </h3>
                        </div>
                        <div className="infos">
                          <div className="classContent">
                            <h4>
                              <FlagIcon code={item.lingoLanguage.flag} />
                              {decryptIfEncrypted(item.lingoLanguage.language.name)}
                            </h4>
                            <div className="classAndTeacher">
                              <div>
                                {item.classScheduleDetails.map((classDetails, i) => {
                                  return (
                                    <div key={i}>
                                      <h4>
                                        {t("CARD_CLASS_CONTENT")}: {classDetails.focus}
                                      </h4>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                            <h4>
                              {" "}
                              {t("CARD_CLASS_TEACHER")} :{" "}
                              {item.teacher ? (
                                <div> {decryptIfEncrypted(item.teacher.user.name)} </div>
                              ) : (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
                                  }}
                                />
                              )}
                              <div dangerouslySetInnerHTML={{ __html: "&nbsp;&nbsp;&nbsp;" }} />
                            </h4>
                          </div>
                          {!item.classScheduleDetails[0].classScheduleReversed &&
                            item.status !== "canceled" &&
                            item.status !== "pending" &&
                            item.status !== "accepted" &&
                            item.status !== "done" && (
                              <div>
                                <button
                                  style={{ width: "auto", height: "auto", padding: "5px 15px" }}
                                  onClick={() => handleReversePayment(item.id)}
                                >
                                  {t("BTN_REVERSE_PAYMENT")}
                                </button>
                              </div>
                            )}

                          {CancelCardItem(item)}

                          {item.status == "pending" && (
                            <div className="status">
                              <h5 className={"scheduleWithoutTeacher"}>{t("WITHOUT_TEACHER")}</h5>
                              {!item.classScheduleDetails[0].classScheduleReversed && (
                                <button
                                  style={{
                                    width: "auto",
                                    height: "auto",
                                    padding: "5px 15px",
                                    marginRight: "20px",
                                  }}
                                  onClick={() => handleReversePayment(item.id)}
                                >
                                  {t("BTN_REVERSE_PAYMENT")}
                                </button>
                              )}
                              {item.classScheduleDetails[0].classScheduleReversed && (
                                <button
                                  style={{
                                    width: "auto",
                                    height: "auto",
                                    padding: "5px 15px",
                                    marginRight: "20px",
                                  }}
                                >
                                  {t("BTN_REVERSED_PAYMENT")}
                                </button>
                              )}
                              <Link to={`/class-details/` + item.id}>
                                <button>
                                  {t("BTN_VIEW")} <i className="fa fa-angle-right" aria-hidden="true"></i>
                                </button>
                              </Link>
                            </div>
                          )}

                          {(item.status == "done" ||
                            (item.status == "noShow" && item.classScheduleDetails[0].classScheduleReversed)) && (
                            <div className="status">
                              <h4>
                                {t("CARD_CLASS_CONFIRMED")} <i className="fa fa-check-circle-o" aria-hidden="true"></i>
                              </h4>
                              {!item.classScheduleDetails[0].classScheduleReversed && (
                                <button
                                  style={{
                                    width: "auto",
                                    height: "auto",
                                    padding: "5px 15px",
                                    marginRight: "20px",
                                  }}
                                  onClick={() => handleReversePayment(item.id)}
                                >
                                  {t("BTN_REVERSE_PAYMENT")}
                                </button>
                              )}
                              {item.classScheduleDetails[0].classScheduleReversed && (
                                <button
                                  style={{
                                    width: "auto",
                                    height: "auto",
                                    padding: "5px 15px",
                                    marginRight: "20px",
                                  }}
                                  disabled
                                >
                                  {t("BTN_REVERSED_PAYMENT")}
                                </button>
                              )}
                              <Link to={`/class-details/` + item.id}>
                                <button>
                                  {t("BTN_VIEW")} <i className="fa fa-angle-right" aria-hidden="true"></i>
                                </button>
                              </Link>
                            </div>
                          )}

                          {item.status == "accepted" && (
                            <div className="status">
                              <h4>
                                {t("CARD_CLASS_CONFIRMED")} <i className="fa fa-check-circle-o" aria-hidden="true"></i>
                              </h4>

                              <Link to={`/class-details/` + item.id}>
                                <button>
                                  {t("BTN_VIEW")} <i className="fa fa-angle-right" aria-hidden="true"></i>
                                </button>
                              </Link>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <Pagination
                pageCurrent={filter.pageNumber}
                totalPages={pagination.totalPages}
                totalFound={pagination.pageSize}
                totalResults={pagination?.totalFound ?? 10}
                onClick={(page, type) => handlePagination(page, type)}
              />
            </>
          )}
        </Next>
      </StudentManagementCss>

      <Dialog
        open={open}
        onClose={closeAlert}
        className="boxModal"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
        <DialogContent className="boxModal">
          <DialogContentText id="pass-dialog-description">{dialogMsg}</DialogContentText>
        </DialogContent>
        <DialogActions className="boxModal">
          <Button onClick={closeAlert} color="primary" autoFocus>
            {t("CLOSE")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Classes;
